import request from '@/utils/request'

/**
 * 获取商城用户信息
 * @param {Object} params 查询参数
 * @param {String} params.userId 用户ID
 * @param {Number} params.page 页码
 * @param {Number} params.row 每页条数
 */
export function getMallUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.queryMallUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteMallUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.deleteMallUser',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function resetMallUserPwd(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.resetMallUserPwd',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}